import { ChevronRight, Home } from "lucide-react";
import type { BreadcrumbItem } from "@/features/files/types/sharepoint";

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  onNavigate: (folderId: string | null) => void;
}

export const Breadcrumb = ({ items, onNavigate }: BreadcrumbProps) => {
  return (
    <nav className="flex items-center gap-1 text-sm overflow-x-auto min-w-0">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={item.id ?? "root"} className="flex items-center gap-1 shrink-0">
            {index > 0 && <ChevronRight className="w-4 h-4 text-gray-400 shrink-0" />}
            <button
              onClick={() => onNavigate(item.id)}
              disabled={isLast}
              className={`flex items-center gap-1 px-1.5 py-1 rounded transition-colors ${
                isLast
                  ? "text-gray-900 font-medium cursor-default"
                  : "text-gray-500 hover:text-indigo-600 hover:bg-indigo-50"
              }`}
            >
              {index === 0 && <Home className="w-4 h-4" />}
              <span className="truncate max-w-[150px]">{item.name}</span>
            </button>
          </span>
        );
      })}
    </nav>
  );
};
